import { Box, Stack } from "@mui/material";
import { useStore } from "@tanstack/react-form";

import { withForm } from "components/Forms/AppForm";

import { ppFilterDefaultValues } from "../../context/ppFilterDefaultValues";
import { useFilteredPps } from "../../hooks/useFilteredPps";

import PpListItem from "./PpListItem";

const PpListView = withForm({
  defaultValues: ppFilterDefaultValues,
  render: function Render({ form }) {
    const filters = useStore(form.store, (state) => state.values);
    const { protectionProfiles } = useFilteredPps(filters);

    return (
      <Box p={2}>
        <Stack gap={2}>
          {protectionProfiles?.map((pp) => {
            if (!pp) return null;

            return <PpListItem key={pp.pp_id} listItem={pp} />;
          })}
        </Stack>
      </Box>
    );
  },
});

export default PpListView;
